export enum MAGENTO_MESSAGES {
    IFRAME_READY = "IFrameReady",
    INIT = "Init",
    MATCH_ACCOUNT = "MatchAccount",
    LOGIN_REQUIRED = "LoginRequired",
    LOGIN_SUCCESS = "LoginSuccess",
    CREATE_ACCOUNT = "CreateAccount",
    ACCOUNT_CREATED = "AccountCreated",
    ORDER_BOM = "OrderBOM"
}